import ApiService from '@/core/services/ApiService';
import JwtService from '@/core/services/JwtService';
import StorageService from '@/core/services/StorageService';

import requests from '../../requests';

export default {
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.put(requests.AUTH_JWT_LOGIN, payload)
        .then((response) => {
          StorageService.saveStorageService('LOGIN_PAYLOAD', payload);
          resolve(response);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  verify({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setBaseUrl(requests.URL_BASE);
        ApiService.setHeader();
        ApiService.get(requests.AUTH_JWT_VERIFY)
          .then((response) => {
            let data = response.data.data;
            let token = JwtService.getToken();
            let user = response.data.data;
            commit('SET_AUTH', { user, token });
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      } else {
        commit('PURGE_AUTH');
      }
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setBaseUrl(requests.URL_BASE);
        ApiService.setHeader();
        ApiService.put(requests.AUTH_JWT_UPDATE_USER, payload)
          .then((response) => {
            let data = response.data.data;
            let token = JwtService.getToken();
            let user = response.data.data;
            commit('SET_AUTH', { user, token });
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      } else {
        commit('PURGE_AUTH');
      }
    });
  },
  verifyOTP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.put(requests.AUTH_JWT_VERIFY_USER, payload)
        .then((response) => {
          let data = response.data.data;
          let token = data.accessToken;
          let user = {};
          commit('SET_AUTH', { user, token });
          resolve(data);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  resendOTP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.put(requests.AUTH_JWT_RESEND_VERIFY_USER, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  logout({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('PURGE_AUTH');
      resolve(1);
    });
  },

  sendOTP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.post(requests.AUTH_JWT_SEND_VERIFY, payload)
        .then((response) => {
          let data = response.data.data;
          let token = data.accessToken;
          let user = {};
          // commit("SET_AUTH", {user, token});
          resolve(data);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  sendOTPEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.post(requests.AUTH_JWT_SEND_VERIFY_EMAIL, payload)
        .then((response) => {
          let data = response.data.data;
          let token = data.token || data.accessToken;
          let user = data.user;
          if (user) {
            commit('SET_AUTH', { user, token });
          } else {
            StorageService.saveStorageService('REGISTER_PAYLOAD', payload);
            if(token) StorageService.saveStorageService('REGISTER_AUTH', token);
          }
          // commit("SET_AUTH", {user, token});
          resolve(data);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  checkOTP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.put(requests.AUTH_JWT_ACTIVE_VERIFY, payload)
        .then((response) => {
          let data = response.data.data;
          let token = data.accessToken;
          let user = data.user;
          if (user) {
            commit('SET_AUTH', { user, token });
          } else {
            StorageService.saveStorageService('REGISTER_PAYLOAD', payload);
            StorageService.saveStorageService('REGISTER_AUTH', token);
          }
          resolve(response);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  register({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      let REGISTER_AUTH = StorageService.getStorageService('REGISTER_AUTH');
      ApiService.setHeaderForced(REGISTER_AUTH);
      ApiService.post(requests.AUTH_JWT_REGISTER, payload)
        .then((response) => {
          let data = response.data.data;
          let token = data.accessToken;
          let user = data.user;
          commit('SET_AUTH', { user, token });
          StorageService.destroyStorageService('REGISTER_AUTH');
          resolve(response);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  checkPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.query(requests.AUTH_JWT_HAS_PASSWORD, {params: payload}).then((response) => {
          resolve(response);
        }).catch((response) => {
          reject(response);
        });
    });
  },
  forgetPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.post(requests.AUTH_JWT_FORGET_PASSWORD, payload).then((response) => {
          resolve(response);
        }).catch((response) => {
          reject(response);
        });
    });
  },
  resetPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.setHeader();
      ApiService.setHeaderForced(payload.token);
      ApiService.put(requests.AUTH_JWT_RESET_PASSWORD, payload).then((response) => {
          resolve(response);
        }).catch((response) => {
          reject(response);
        });
    });
  },
};
